
import Vue from 'vue';
import { defineComponent, PropType } from 'vue';
import { BackEndContent } from '@/models/Blocks/backend-content';
import { DeviceType } from "@/models/Blocks/Itens/Types/device-type";
import { BlockSession } from '@/models/Blocks/block-session';
import { Banner, BannerItem } from '@/models/Blocks/banner';
import { Picture, PictureSource } from '@/models/Muffin/picture';
import { Webp } from "@/models/Muffin/webp";
import Mub from '@/components/Mub.vue';

import PrzBannerContent from './BannerContent.vue';
import VueObserveVisibility from 'vue-observe-visibility';
import baseUrl from "@/api/base-url";

Vue.use(VueObserveVisibility);

export default defineComponent({
    components:{
        PrzBannerContent,
        Mub
    },
    props: {
        bannerId: {
            type: String,
            default: undefined
        },
        bannerData:{
            type: Array as PropType<Banner>,
            default: undefined
        },
        bannerParams: {
            type: String,
            default: undefined
        },
        bannerSpecs: {
            type: String,
            default: undefined
        },
        ttl: {
            type: Number,
            default: 3600
        },
        contentUrl: {
            type: String,
            default: baseUrl.getUrl('site/block')
        },
        autoChange:{
            type: Boolean,
            default: true
        },
        changeTimeMs:{
            type: Number,
            default: 10000
        },
    },
    data() {
        let items: Banner = [];
        let play: Array<boolean> = [];
        let events: {[key: string]: boolean} = {};
        let noContent: boolean = false;
        let timerToChange: any|undefined = undefined;
        return {
            items,
            play,
            events,
            noContent,
            indexSelected: 0,
            timerToChange,
            scrollChange: false
        }
    },
    computed: {
        device():DeviceType{
            return DeviceType.mobile
        },
        isMobile():boolean{
            return this.device == DeviceType.mobile;
        },
        getMubData(): Object|undefined{
            if(this.items.length && this.items[0].oti){
                return {
                    t: 'banners',
                    b: this.items[0].oti,
                };
            }
            
            return undefined;
        }
    },
    mounted(){
        try{
            if(this.bannerData && this.bannerData.length > 0) {
                this.setBanners(this.bannerData, true);
            }else if(!this.bannerData){
                //load from storage  
                let blockData = BlockSession.getInstance().getBlockData(`bnr${this.bannerId}`,this.bannerParams,'-');
                if(blockData && blockData.content){
                    this.setBanners(blockData.content, true);
                }
            }
        }catch(e) {}
    },
    methods: {
        scroll(p: any){
            this.scrollChange = true;
            let elem: HTMLElement|null = p?.target ?? null;
            if(elem){
                let width: number = this.$el.clientWidth;
                this.indexSelected = Math.round(elem.scrollLeft / width);
            }
        },
        selectFormat(image: string): string{
            if(this.isMobile || !this.supportWebp(image)){
                return image;
            }
            return image.replace('.jpg','.webp');
        },
        selectVideo(item: BannerItem):string|undefined{
            return item.videoFull ? item.videoFull : undefined;
        },
        selectPicture(item: BannerItem): Picture{
            let main = item.minImg || item.image;
            let list: Array<PictureSource> = [];
            if(item.minImg){
                if(this.supportWebp(item.minImg)  && !this.isMobile){
                    list.push({url: item.minImg.replace('.jpg','.webp')})
                    list.push({url: item.image.replace('.jpg','.webp'), condition: '2x'});
                }
                list.push({url: item.image, condition: '2x'});
            }else{
                if(this.supportWebp(item.image) && !this.isMobile){
                    list.push({url: item.image.replace('.jpg','.webp')})
                }
            }
            let p = new Picture(main,list);
            p.title  = item.title;
            return p;
        },
        supportWebp(image: string){
            let isJpg: boolean = image !='' && image.indexOf('.jpg') !== -1;
            if(Webp.support() && isJpg){
                return true;
            }
            return false;
        },
        getBannerVideo(index: number):HTMLVideoElement|null {
            let banner: any = this.$refs[`bnr${index}`] ?? null;
            if(banner){
                let videoSel: HTMLElement = Array.isArray(banner) ? banner[0] : banner;
                if(videoSel){
                    let video: HTMLVideoElement|null = videoSel.querySelector('video');
                    return video;
                }
            }
            return null;
        },
        selectBanner(index: number){
            let width: number = this.$el.clientWidth;
            let step: number  = index - this.indexSelected;
            let elem: HTMLElement|null = this.$refs.container ? (this.$refs.container as HTMLElement) : null;
            this.autoChange && clearTimeout(this.timerToChange);
            if(step && elem && width){
                let value: number = width * step;
                elem.scrollBy({
                    top: 0, 
                    left: value,
                    behavior: 'smooth'
                });
            }
            //this.setAutoNext();
        },
        goToNext(){
            if(this.items.length <= 1){
                return;
            }
            let next: number = this.indexSelected + 1;
            if(next >= this.items.length){
                next = 0;
            }
            this.selectBanner(next);
        },
        setBanners(content: Banner, fromCache: boolean){
            this.play  = Array(content.length).fill(false); 
            this.items = content;
            if(!fromCache){
                const blockData = {
                    content: content,
                }
                
                BlockSession.getInstance().setBlockData(blockData, `bnr${this.bannerId}`, this.bannerParams, this.ttl, '-');
            }
            if (this.items.length == 0) {
                this.noContent = true;
            }
        },
        async visibilityChanged() {
            if(this.items.length > 0 || this.noContent){
                return;
            }

            if(!this.bannerParams || !this.bannerId){
                return [];
            }

            let paramsData: object = {
                [this.bannerId]: {
                    id: this.bannerId,
                    params: this.bannerParams,
                    specs: this.bannerSpecs,
                    props: btoa(JSON.stringify({})),
                    order: 1
                }
            };
            
            //load from backend
            const data = await BackEndContent.get(this.contentUrl, paramsData, false);
            Object.keys(data).forEach((id) => {
                let blockData = [];
                if (id == this.bannerId) {
                    blockData = data[id] ?? null;
                    this.setBanners(blockData?.elements ?? [], false);
                }
            });
        },
    }
});
